<div>Testing grid</div>
<jqxTreeGrid [width]="1000" [source]="dataAdapter" [pageable]="true" [sortable]="true" [columns]="columns"
    [ready]="ready" [height]="400" #TreeGrid>
</jqxTreeGrid>

<div style="margin-top: 20px;">
    <div style="float: left;">
        <jqxButton #excelExport (onClick)="excelExportClick()">Export to Excel</jqxButton>
    </div>
    <div style="float: left;">
        <jqxButton #htmlExport (onClick)="htmlExportClick()">Export to HTML</jqxButton>
        <br />
        <br />
        <jqxButton #jsonExport (onClick)="jsonExportClick()">Export to JSON</jqxButton>
    </div>
</div>